import { DateField } from 'admin';
import type { Load } from 'api';
import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { ListItem, ListItemSecondaryAction, ListItemText } from 'ui';

export const LoadListItem = ({ load, children }: { load: Load; children?: ReactNode }) => {
  return (
    <ListItem to={`/ground-control/inspections/loads?loadId=${load.id}`} component={Link}>
      <ListItemText
        primary={load.name}
        secondary={
          load.estimated_collection_time ? (
            <DateField value={load.estimated_collection_time} format="LLL" component="span" />
          ) : null
        }
      />
      {children ? <ListItemSecondaryAction>{children}</ListItemSecondaryAction> : null}
    </ListItem>
  );
};
